module.exports = __webpack_public_path__ + "img/library.b02b3bac.svg";